var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.154 4.37676C11.4815 4.06181 11.4815 3.55117 11.154 3.23622C10.8265 2.92126 10.2956 2.92126 9.96811 3.23622L5.99961 7.05297L2.03111 3.23622C1.70363 2.92126 1.17269 2.92126 0.845215 3.23622C0.51774 3.55117 0.51774 4.06181 0.845216 4.37676L5.40666 8.76378C5.73414 9.07874 6.26508 9.07874 6.59256 8.76378L11.154 4.37676Z",
    fill: "#42572C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b8f655bd2805d9185842ec5da20d76e1.svg";
export { ForwardRef as ReactComponent };